import { useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { GenerateField } from "./GenerateField";

export function PostalPointField({ label }: { label?: string }) {
  const {
    formState: { errors },
  } = useFormContext();

  const fieldName = "postal_point";
  const hasError = !!errors[fieldName]?.type;

  return (
    <GenerateField
      errorText="Required field"
      name={fieldName}
      rules={{
        validate: (value) => !!value?.trim(),
      }}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          error={hasError}
          label={label || "Number of Service Point"}
          variant="filled"
          inputProps={{
            maxLength: 2000,
          }}
        />
      )}
    />
  );
}
